import { render, staticRenderFns } from "./List.vue?vue&type=template&id=e99bd070&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=e99bd070&scoped=true&lang=css&"
import style1 from "./List.vue?vue&type=style&index=1&id=e99bd070&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99bd070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e99bd070')) {
      api.createRecord('e99bd070', component.options)
    } else {
      api.reload('e99bd070', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=e99bd070&scoped=true&", function () {
      api.rerender('e99bd070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/quotation-requests/List.vue"
export default component.exports